import React, { useEffect, useState } from 'react'
import { logout } from '../../../feature/AuthSlice';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Alert from '../../../feature/Alert';
import { useLogoContext } from '../logo/LogoContext';
import { IMAGE_PATH } from '../../../data/constant';
import { useUserContext } from '../user/UserContext';

export default function Header() {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { logo } = useLogoContext();

    const {userData} = useUserContext();

    const [rigthSidebar, setRightSidebar] = useState(false);

    const toggleSidebar = (status) => {
        setRightSidebar(status);
    }

    const handelLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        dispatch(logout());
        Alert.success("Logout Success!");
        navigate('/login');
    }

    useEffect(() => {
        setSideBar();    
    }, [])

    const setSideBar = () => {
        let sideBarStatus = localStorage.getItem("sideBarStatus");
        if (sideBarStatus === null || sideBarStatus === 'open') {
            document.body.classList.remove('sidebar-icon-only');
        } else {
            document.body.classList.add('sidebar-icon-only');
        }
    }

    const handelSidebar = () => {
        let sideBarStatus = localStorage.getItem("sideBarStatus");
        if (sideBarStatus === null || sideBarStatus === 'open') {
            localStorage.setItem('sideBarStatus', 'close');
            document.body.classList.add('sidebar-icon-only');
        } else {
            localStorage.setItem('sideBarStatus', 'open');
            document.body.classList.remove('sidebar-icon-only');
        }
    }

    const changeLanguage = () => {
        let lng = currentLanguage == 'en' ? 'mr' : 'en';
        localStorage.setItem('language',lng);
        i18n.changeLanguage(lng);
    };

    return (
        <>
            <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
                <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                    <Link className="navbar-brand brand-logo mr-5" to={"/root"}>{logo && logo.logo !== undefined && <img src={`${IMAGE_PATH}/logo/${logo.logo}`} className="mr-2" alt="logo" />}</Link>
                    <Link className="navbar-brand brand-logo-mini" to={"/root"}>{logo && logo.favicon !== undefined && <img src={`${IMAGE_PATH}/logo/${logo.favicon}`} alt="logo" />}</Link>
                </div>
                <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
                    <button className="navbar-toggler navbar-toggler align-self-center" type="button" onClick={handelSidebar}>
                        <span className="icon-menu"></span>
                    </button>
                    <ul className="navbar-nav mr-lg-2">
                        <li className="nav-item d-none d-lg-block">
                            <a className="btn btn-sm btn-primary btn-rounded "  onClick={(e) => setRightSidebar(true)}>
                                <i className="icon-plus"></i>
                            </a>
                        </li>
                        <li className="nav-item d-none d-lg-block">
                            {userData && <span>Welcome : {userData.first_name} {userData.last_name}</span>}
                        </li>
                    </ul>
                    <ul className="navbar-nav navbar-nav-right">
                        <li className="nav-item nav-profile dropdown">
                            <a className="nav-link dropdown-toggle" href="#" data-toggle="dropdown" id="profileDropdown">
                                <i className="icon-ellipsis"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
                                <Link className="dropdown-item text-primary" to={"/root/setting/profile"}>
                                    <i className="ti-user "></i>
                                    {t('profile')}
                                </Link>
                                <Link className="dropdown-item text-secondary" to={"/root/setting/changePass"}>
                                    <i className="ti-settings "></i>
                                    {t('change_password')}
                                </Link>
                                <Link className="dropdown-item text-warning" to={"/root/setting/shortKeys"}>
                                    <i className="ti-settings"></i>
                                    {t('short_keys')}
                                </Link>
                                <a className="dropdown-item text-info" onClick={changeLanguage}>
                                    <i className="mdi mdi-compass "></i>
                                    {currentLanguage == 'en' ? 'Marathi' : 'English'}
                                </a>
                                <a className="dropdown-item text-danger" onClick={handelLogout}>
                                    <i className="ti-power-off "></i>
                                    {t('logout')}
                                </a>
                            </div>
                        </li>                        
                    </ul>
                    <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas" onClick={handelSidebar}>
                        <span className="icon-menu"></span>
                    </button>
                </div>
            </nav>
            <div id="right-sidebar" className={`settings-panel ${rigthSidebar ? 'open' : ''}`}>
                <i className="settings-close ti-close btn btn-sm" onClick={(e) => setRightSidebar(false)}></i>
                <div className='p-3 mt-4'>
                    <div className='border p-2 border-dark'>
                        <Link to={"/root/invoices/new"} className='btn btn-sm btn-primary btn-block mt-3'>{t('new')}  {t('invoice')}</Link>
                        <Link to={"/root/po/new"} className='btn btn-sm btn-secondary btn-block mt-3'>{t('new')}  {t('purchase_order')}</Link>
                        <Link to={"/root/customer/add"} className='btn btn-sm btn-warning btn-block mt-3'>{t('new')}  {t('customer')}</Link>
                        <Link to={"/root/vendor/add"} className='btn btn-sm btn-success btn-block mt-3'>{t('new')}  {t('vendor')}</Link>
                        <Link to={"/root/payment/customerPayment"} className='btn btn-sm btn-danger btn-block mt-3'>{t('new')}  {t('customer_payment')}</Link>
                        <Link to={"/root/payment/vendorPayment"} className='btn btn-sm btn-dark btn-block mt-3'>{t('new')}  {t('vendor_payment')}</Link>
                        <Link to={"/root/expense/new"} className='btn btn-sm btn-info btn-block mt-3'>{t('new')}  {t('expense')}</Link>
                        <Link to={"/root/bill/new"} className='btn btn-sm btn-primary btn-block mt-3'>{t('new')}  {t('bill')}</Link>
                    </div>
                </div>
            </div>
        </>
    )
}
